// @ts-nocheck
import { Routes, Route } from 'react-router-dom';
import TransitionsPage from './TransitionsPage';
import InteractivePage from './InteractivePage';
import ScrollPage from './ScrollPage';
import AttentionPage from './AttentionPage';
import LoadingPage from './LoadingPage';
import GesturesPage from './GesturesPage';
import PageTransitionsPage from './PageTransitionsPage';
import MantineTransitionsPage from './MantineTransitionsPage';

export default function AnimationsRoutes() {
  return (
    <Routes>
      <Route path="transitions" element={<TransitionsPage />} />
      <Route path="interactive" element={<InteractivePage />} />
      <Route path="scroll" element={<ScrollPage />} />
      <Route path="attention" element={<AttentionPage />} />
      <Route path="loading" element={<LoadingPage />} />
      <Route path="gestures" element={<GesturesPage />} />
      <Route path="page-transitions" element={<PageTransitionsPage />} />
      <Route path="mantine" element={<MantineTransitionsPage />} />
    </Routes>
  );
}
